import { browser, dev } from '@dh-io-owpi/shared/src/environment';
import { buildQuery } from '../../utils/buildQuery';
import { sendServiceError } from '../Error';

// We only use the prod deeplink service env because the other envs have bad link urls
const apiVehicleDeeplinksBaseUrl = 'https://api.oneweb.mercedes-benz.com/vehicle-deeplinks-api';

/**
 * @description Provides the configurator, online shop and test drive urls with the correspondent labels.
 *
 * @name getDeeplinks
 * @summary Endpoint for get deeplinks by Model Series
 * @request GET:/v1/deeplinks/${country}/${language}/model-series/${modelSeries}
 *
 */
export async function getDeeplinks({ country, language, modelSeries, brandId }: GetDeeplinksParams) {
  // To avoid local cors problems with deeplink service we get the data from a local proxy server
  const baseUrl =
    !dev || !browser || 'IS_ON_PW' in window
      ? apiVehicleDeeplinksBaseUrl
      : new URL(import.meta.url).origin + '/vehicle-deeplinks-api';

  // Vehicle Deeplinks API doesn't have MERCEDES_BENZ sub-brand and if specified It throws an error.
  const queryString = buildQuery({
    subBrands: brandId === 'MERCEDES_BENZ' ? undefined : brandId,
    cmsInstance: 'PUBLISHER',
  });

  try {
    return (await fetch(`${baseUrl}/v1/deeplinks/${country}/${language}/model-series/${modelSeries}?${queryString}`) //
      .then((r) => {
        if (!r.ok) throw new Error(`getDeeplinks: ${r.status} ${r.statusText}`);

        return r.json();
      })) as Promise<Deeplinks>;
  } catch (error) {
    // @ts-ignore - we just need this bits of aemData
    sendServiceError({ country, language, modelSeries, subBrand: brandId }, error, 'vehicle-deeplinks-api');
    throw error;
  }
}

export interface GetDeeplinksParams {
  country: string;
  language: string;
  modelSeries: string;
  brandId?: string;
}

export type ProductType = 'CONFIGURATOR' | 'ONLINE_SHOP' | 'PRODUCT_PAGE' | 'TEST_DRIVE';

export type Deeplinks = Partial<Record<ProductType, Deeplink>>;

export interface Deeplink {
  label: string;
  url: string;
}
